var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.492 6.5h-.984a.53.53 0 00-.02 0c-.28.01-.498.224-.488.479l.183 6.88a.667.667 0 00.666.641h.28a.667.667 0 00.666-.639L13 6.981v-.02c0-.254-.227-.461-.508-.461zM11 16.5a1 1 0 102 0 1 1 0 00-2 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm8.5-10a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z",
    fill: "currentColor"
  })));
}
export default SvgExclamationCircle;